<template name="dialog-confirm">
	<div class="delete-confirm-dialog">
		<!-- 确认删除活动 -->
		<el-dialog
		  title="温馨提示"
		  :visible.sync="show"
		  :before-close="close"
		  :close-on-click-modal="false"
		>
			<div class="tip" v-if="tipShow">
				<p class="tip-one">当前团购活动正在进行推广，如需删除请先取消推广</p>
				<p class="tip-one">● 请前往“<span class="ahref" @click="go_plan()">专属计划</span>”删除推广计划</p>
			</div>
			<p class="tip" v-else>
				删除操作需谨慎，确定删除吗？
			</p>
			
			<div slot="footer">
				<el-button @click="close">取消</el-button>
				<el-button type="primary" @click="confirm" :disabled="disabled">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		del,
		getRelationPlan
	} from '@/api/event';
	export default {
		data() {
			return {
				disabled: true,
				tipShow: false
			};
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			event_id: {
				type: Number,
				default: 0,
			},
		},
		watch:{
			show: function(newVal, oldVal){
				if(newVal){
					this.getPlanCount();
				}
			}
		},
		methods: {
			_reset(){
				this.tipShow = false;
				this.disabled = true;
			},
			close() {
				this.$emit('close');
				this._reset()
			},
			confirm() {
				del({
					event_id: this.event_id,
				}).then(res => {
					if (res.code == 0) {
						this.$message.success(res.message);
						this.$emit('success');
						this._reset()
					} else {
						this.$message.error(res.message);
					}
				})
			},
			getPlanCount() {
				getRelationPlan({
					event_id: this.event_id,
				}).then(res=>{
					if(res.code==0){
						if(res.data.plan_id >0){
							this.tipShow = true;
						}else{
							this.disabled = false;
						}
					}else{
						this.$message.error(res.message);
					}
				})
			},
			// 进入专属计划页面
			go_plan(){
				this.$router.push({
					path: '/goods/exclusive',
					query: {}
				});
			}
		},
		mounted() {
			
		}
	}
</script>

<style scoped>
	.delete-confirm-dialog .el-dialog__body {
		padding-top: 0;
		padding-bottom: 16px;
	}
	.delete-confirm-dialog .el-dialog {
		width: 424px;
	}
	.delete-confirm-dialog .tip {
		padding: 10px 20px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 24px;
	}
	.delete-confirm-dialog .el-dialog__footer {
		padding-top: 0;
		padding-bottom: 16px;
	}
	
	.delete-confirm-dialog .tip{
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #666666;
	}
	.delete-confirm-dialog .tip-one{
		margin-bottom: 10px;
	}
	.delete-confirm-dialog .ahref{
		color: #409EFF;
		cursor: pointer;
	}
</style>
